module.exports = __webpack_public_path__ + "img/facebook_instagram.9f1f9b49.svg";